module.exports = __webpack_public_path__ + "static/media/GeneracionDistribuida.4b457341.jpg";